import React from 'react';
import { Outlet, Link, useNavigate } from 'react-router-dom';
import AdminHeader from './AdminHeader/AdminHeader';
import API from '../../services/api';

const AdminLayout = () => {
  const navigate = useNavigate();

  const handleLogout = async (e) => {
    e.preventDefault();
    try {
      await API.logout();
    } catch (error) {
      console.error("Logout API failed, proceeding with local logout", error);
    } finally {
      localStorage.removeItem("adminToken");
      navigate("/");
    }
  };

  return (
    <div className="admin-layout" style={{ display: 'flex', flexDirection: 'column', minHeight: '100vh' }}>
      {/* Header spanning full width at top */}
      <AdminHeader />

      {/* Main content area containing Sidebar and Outlet */}
      <div style={{ display: 'flex', flex: 1, overflow: 'hidden' }}>
        {/* Sidebar */}
        <aside style={{ width: '50px', background: '#333', color: '#fff', padding: '20px 0', display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
          <ul style={{ listStyle: 'none', padding: 0, margin: 0, display: 'flex', flexDirection: 'column', gap: '20px' }}>
            <li>
              <Link to="/admin/dashboard" style={{ color: '#fff', textDecoration: 'none' }} title="Dashboard">
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor" viewBox="0 0 16 16">
                  <path d="M8 4a.5.5 0 0 1 .5.5V6a.5.5 0 0 1-1 0V4.5A.5.5 0 0 1 8 4M3.732 5.732a.5.5 0 0 1 .707 0l.915.914a.5.5 0 1 1-.708.708l-.914-.915a.5.5 0 0 1 0-.707M2 10a.5.5 0 0 1 .5-.5h1.586a.5.5 0 0 1 0 1H2.5A.5.5 0 0 1 2 10m9.5 0a.5.5 0 0 1 .5-.5h1.5a.5.5 0 0 1 0 1H12a.5.5 0 0 1-.5-.5m.754-4.246a.389.389 0 0 0-.527-.02L7.547 9.31a.91.91 0 1 0 1.302 1.258l3.434-4.297a.389.389 0 0 0-.029-.518z"/>
                  <path fillRule="evenodd" d="M0 10a8 8 0 1 1 15.547 2.661c-.442 1.253-1.845 1.602-2.932 1.25C11.309 13.488 9.475 13 8 13c-1.474 0-3.31.488-4.615.911-1.087.352-2.49.003-2.932-1.25A8 8 0 0 1 0 10m8-7a7 7 0 0 0-6.603 9.329c.203.575.923.876 1.68.63C4.397 12.533 6.358 12 8 12s3.604.532 4.923.96c.757.245 1.477-.056 1.68-.631A7 7 0 0 0 8 3"/>
                </svg>
              </Link>
            </li>
            <li>
              <a href="/" onClick={handleLogout} style={{ color: '#aaa', textDecoration: 'none', cursor: 'pointer' }} title="Logout">
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor" className="bi bi-power" viewBox="0 0 16 16">
                  <path d="M7.5 1v7h1V1h-1z"/>
                  <path d="M3 8.812a4.999 4.999 0 0 1 2.578-4.375l-.485-.874A6 6 0 1 0 11 3.616l-.501.865A5 5 0 1 1 3 8.812z"/>
                </svg>
              </a>
            </li>
          </ul>
        </aside>

        {/* Main Content */}
        <main style={{ flex: 1, minWidth: 0, padding: '20px', background: '#f4f6f8', overflowX: 'hidden', overflowY: 'auto' }}>
          {/* The nested routes will render inside Outlet */}
          <Outlet />
        </main>
      </div>
    </div>
  );
};

export default AdminLayout;
